export default {
  app: {
    title: "ड्रीम शब्द बॉक्स",
    language: "हिन्दी"
  },

  pages: {
    app: {
      myAccount: "मेरा खाता",
      editProfile: "प्रोफ़ाइल संपादित करें",

      boxScenarios: "बॉक्स परिदृश्य",
      scenario1Title: "आधा दिन बॉक्स",
      scenario1Desc: "बॉक्स की हर आधे दिन में समीक्षा करें (जैसे सुबह और शाम)।",

      scenario2Title: "दैनिक बॉक्स",
      scenario2Desc: "दिन में एक बार बॉक्स की समीक्षा करें।",

      scenario3Title: "बॉक्स संख्या दिन",
      scenario3Desc: "बॉक्स संख्या के आधार पर अंतराल पर समीक्षा करें (जैसे बॉक्स 3 हर 3 दिन में)।",

      username: "यूज़रनेम",
      usernameHint: "लॉगिन के लिए आपका विशिष्ट यूज़रनेम",

      name: "नाम",
      nameHint: "हम आपको क्या कहकर बुलाएं?",

      email: "ईमेल पता",
      emailHint: "पासवर्ड रिकवरी के लिए ईमेल (वैकल्पिक)",

      changePassword: "पासवर्ड बदलें",
      changePasswordHint: "यदि आप पासवर्ड नहीं बदलना चाहते हैं, तो इस फ़ील्ड को खाली छोड़ दें (वैकल्पिक)",

      logout: "लॉगआउट",
      confirmLogout: "लॉगआउट की पुष्टि करें",
      confirmLogoutText: "क्या आप वाकई लॉगआउट करना चाहते हैं?",
      cancel: "रद्द करें",

      close: "बंद करें",
      updateProfile: "प्रोफ़ाइल अपडेट करें",

      myWords: "मेरे शब्द",
      addNewWord: "नया शब्द/मुहावरा जोड़ें",
      boxes: "बॉक्स",

      applicationSettings: "एप्लिकेशन सेटिंग्स",

      autoSpeechOnChecking: "दिखना शुरू होने पर शब्द को स्वतः बोलें",
      autoDetectClipboardChange: "क्लिपबोर्ड टेक्स्ट का स्वतः पता लगाएं",

      clipboardPermissionText: "एप्लिकेशन को ब्राउज़र सेटिंग्स में क्लिपबोर्ड एक्सेस करने की अनुमति चाहिए। अधिक सहायता के लिए, यहाँ क्लिक करें।",

      clipboardHelpTitle: "क्लिपबोर्ड एक्सेस कैसे सक्षम करें",

      chrome: "क्रोम",
      firefox: "फ़ायरफ़ॉक्स",
      safari: "सफ़ारी",

      chromeStep1: "क्रोम ब्राउज़र खोलें।",
      chromeStep2: "ब्राउज़र की सेटिंग्स में जाएं।",
      chromeStep3: "साइट सेटिंग्स या सेटिंग्स सेक्शन ढूंढें।",
      chromeStep4: "अनुमतियों (Permissions) पर जाएं और क्लिपबोर्ड सक्षम करें।",

      firefoxStep1: "फ़ायरफ़ॉक्स ब्राउज़र खोलें।",
      firefoxStep2: "ब्राउज़र की सेटिंग्स में जाएं।",
      firefoxStep3: "अनुमतियाँ सेक्शन ढूंढें और क्लिपबोर्ड एक्सेस सक्षम करें।",

      safariStep1: "अपने फ़ोन का सेटिंग्स ऐप खोलें।",
      safariStep2: "सफ़ारी पर जाएं।",
      safariStep3: "क्लिपबोर्ड से संबंधित सेटिंग्स ढूंढें और उन्हें सक्षम करें।",

      otherBrowserTitle: "यदि किसी अन्य ब्राउज़र का उपयोग कर रहे हैं",
      otherBrowserStep1: "ब्राउज़र सेटिंग्स में समान अनुमतियाँ या साइट सेटिंग्स विकल्प ढूंढें और क्लिपबोर्ड एक्सेस सक्षम करें।",

      speechNotSupported: "आपका ब्राउज़र स्पीच सिंथेसिस (SpeechSynthesis) का समर्थन नहीं करता है",

      ttsSettings: "टेक्स्ट टू स्पीच सेटिंग्स",
      sampleText: "परीक्षण भाषण के लिए टेक्स्ट",

      rate: "गति",
      rateHint: "भाषण की गति को नियंत्रित करता है।",

      pitch: "पिच",
      pitchHint: "आवाज की पिच को समायोजित करता है।",

      volume: "आवाज़",
      volumeHint: "भाषण की आवाज़ का स्तर सेट करता है।",

      friends: "दोस्त",
      messages: "संदेश",

      addToMyWords: "{word} को मेरे शब्दों में जोड़ें",
      viewInMyList: "मेरी सूची में {word} देखें",

      wordSuggestion: "शब्द सुझाव",
      goToAddWord: "नया शब्द जोड़ने पर जाएं",

      updateCompleted: "अपडेट सफलतापूर्वक पूरा हुआ",
      latestChanges: "हाल के संस्करणों में नवीनतम बदलाव",
      version: "संस्करण",
      gotIt: "समझ गया"
    },
    addVocabulary: {
      title: "नया शब्द जोड़ें",
      add: "जोड़ें",
      word: "शब्द / वाक्यांश",
      meaning: "अर्थ",
      example: "उदाहरण",
      description: "विवरण"
    },
    vocabularies: {
      searchLabel: "टेक्स्ट खोजें",
      listLength: "सूची की लंबाई",
      boxNumber: "बॉक्स संख्या",
      nothingFound: "कुछ नहीं मिला !!!",
      adjustFilters: "कृपया अपने फ़िल्टर समायोजित करने का प्रयास करें",
      tableWord: "शब्द",
      tableAction: "कार्रवाई",
      showDetails: "विवरण दिखाएं",
      completeInfo: "पूरी जानकारी",
      meaning: "अर्थ",
      example: "उदाहरण",
      description: "विवरण",
      close: "बंद करें",
      editTitle: "संपादित करें",
      editBtn: "संपादित करें",
      deleteTitle: "{word} को हटाएं",
      deleteConfirmText: "क्या आप वाकई इस शब्द को हटाना चाहते हैं? कृपया ध्यान दें कि एक बार हटाने के बाद, इसे बहाल नहीं किया जा सकता है।",
      yes: "हाँ!",
      no: "नहीं"
    },
    messages: {
      wordSuggestions: "शब्द सुझाव"
    },
    login: {
      signInTitle: "साइन इन करें",
      signInBtn: "साइन इन करें",
      registerTitle: "पंजीकरण करें",
      registerBtn: "पंजीकरण करें",
      registerLink: "पंजीकरण",
      username: "यूज़रनेम",
      password: "पासवर्ड",
      nickname: "नाम",
      email: "ईमेल पता",
      noAccount: "क्या आपने अभी तक पंजीकरण नहीं किया है?",
      haveAccount: "मेरा एक खाता है।",
      usernameHint: "लॉगिन के लिए आपका विशिष्ट यूज़रनेम",
      nicknameHint: "हम आपको क्या कहकर बुलाएं?",
      emailHint: "पासवर्ड रिकवरी के लिए ईमेल (वैकल्पिक)",
      passwordHint: "बिना किसी नियम के पासवर्ड, जो चाहें दर्ज करें",
      orContinueWith: "या इसके साथ जारी रखें...",
      guestRegister: "अतिथि के रूप में त्वरित पंजीकरण 😒"
    },
    reviewVocabulary: {
      showMeaning: "अर्थ दिखाएं",
      hideMeaning: "अर्थ छिपाएं",
      meaning: "अर्थ",
      example: "उदाहरण",
      description: "विवरण",
      playPhrase: "PlayPhrase.me",
      prev: "पिछला",
      next: "अगला"
    },
    checkVocabulary: {
      showMeaning: "अर्थ दिखाएं",
      hideMeaning: "अर्थ छिपाएं",
      wordsRemain: "शब्द शेष",
      lastOne: "अंतिम",
      meaning: "अर्थ",
      example: "उदाहरण",
      description: "विवरण",
      playPhrase: "PlayPhrase.me",
      iRemember: "मुझे याद है",
      iDontRemember: "मुझे याद नहीं है"
    },
    boxes: {
      all: "सभी बॉक्स दिखाएं",
      box: "बॉक्स",
      empty: "खाली",
      needsChecking: "चेक करने की आवश्यकता है",
      checked: "चेक किया गया",

      total: "कुल",
      waiting: "प्रतीक्षा कर रहा है",
      waitingForCheck: "चेक के लिए प्रतीक्षा",

      closestReview: "निकटतम समीक्षा",
      notScheduled: "अभी तक निर्धारित नहीं",

      deeplyMemorized: "आपने {count} शब्दों को गहराई से याद कर लिया है।",
      notReachedYet: "ओह! आप अभी तक इस बॉक्स तक नहीं पहुंचे हैं।",

      startChecking: "चेक करना शुरू करें",
      review: "समीक्षा",
      viewAllWords: "सभी शब्द देखें",
      addNew: "नया जोड़ें",
      itsEmpty: "यह खाली है"
    },
    friends: {
      searchInUsers: "उपयोगकर्ताओं में खोजें",
      searchList: "खोज सूची",
      noUsersYet: "अभी तक कोई उपयोगकर्ता नहीं है।",
      searchUsersAndSendRequest: "आप उपयोगकर्ताओं को खोज सकते हैं और मित्र अनुरोध भेज सकते हैं",
      friendList: "मित्र सूची",
      noFriendsYet: "अभी तक कोई मित्र नहीं है।"
    }
  },

  plugins: {
    axios: {
      postRequestError: "अनुरोध भेजते समय त्रुटि हुई"
    }
  },

  components: {
    shareButton: {
      shareTitle: "{word} साझा करें",
      messageOptional: "संदेश (वैकल्पिक)"
    },
    userList: {
      cancelRequest: "अनुरोध रद्द करें",
      unfriend: "मित्रता समाप्त करें",
      sendRequest: "अनुरोध भेजें",
      accept: "स्वीकार करें",
      reject: "अस्वीकार करें",

      share: "साझा करें",
      addedBefore: "इसे पहले ही जोड़ दिया गया है",

      deeplyMemorized: "{name} ने {count} शब्दों को गहराई से याद कर लिया है।",
      notReachedBox: "{name} अभी तक इस बॉक्स तक नहीं पहुंचा है।",

      totalVocabularies: "कुल शब्दावली",
      registerAge: "पंजीकरण की अवधि",
      lastCheck: "पिछली जांच",
      lastAddedVocabulary: "पिछली जोड़ी गई शब्दावली",
      totalChecks: "कुल जांच",
      averageDailyCheck: "औसत दैनिक जांच",
      averageDailyLearnedCheck: "औसत दैनिक सीखी गई जांच",
      averageDailyNotLearnedCheck: "औसत दैनिक नहीं सीखी गई जांच",
      averageDailyAdd: "औसत दैनिक वृद्धि"
    }
  },

  public: {
    close: "बंद करें"
  },
  "apiResultStatusCodes": {
    "0": "ऑपरेशन विफल हुआ",
    "1": "ऑपरेशन सफल हुआ",
    "2": "एक त्रुटि हुई",
    "3": "भेजे गए पैरामीटर अमान्य हैं",
    "4": "नहीं मिला",
    "5": "प्रमाणीकरण त्रुटि",
    "6": "यह आइटम पहले से पंजीकृत है",
    "7": "यह उपयोगकर्ता पहले से पंजीकृत है",
    "8": "निर्दिष्ट उपयोगकर्ता मौजूद नहीं है",
    "9": "गलत पासवर्ड",
    "10": "अमान्य पैरामीटर",
    "11": "लॉगिन विफल",
    "12": "प्रवेश अस्वीकृत",
    "13": "आइटम नहीं मिला",
    "14": "यह उपयोगकर्ता नाम पहले से चुना जा चुका है",
    "15": "यह ईमेल पहले से उपयोग में है",
    "16": "उपयोगकर्ता नाम आवश्यक है",
    "17": "निकनेम आवश्यक है",
    "18": "पासवर्ड आवश्यक है",
    "19": "उपयोगकर्ता नाम में स्पेस नहीं हो सकता",
    "20": "पंजीकरण सफलतापूर्वक पूरा हुआ",
    "21": "लॉगिन सफलतापूर्वक पूरा हुआ",
    "22": "पासवर्ड में स्पेस नहीं हो सकता",
    "23": "शब्द सफलतापूर्वक जोड़ा गया",
    "24": "शब्द सफलतापूर्वक अपडेट किया गया",
    "25": "शब्द सफलतापूर्वक हटाया गया",
    "26": "आपने यह शब्द पहले ही जोड़ दिया है",
    "27": "शब्द आवश्यक है",
    "28": "कोई शब्द नहीं मिला",
    "29": "बधाई हो! इस बॉक्स के सभी शब्द जाँच लिए गए हैं",
    "30": "आप शब्द फ़ील्ड बदल नहीं सकते",
    "31": "कृपया आवश्यक फ़ील्ड भरें",
    "32": "कोई परिवर्तन नहीं मिला",
    "33": "निर्दिष्ट उपयोगकर्ता रिपॉज़िटरी में मौजूद नहीं है",
    "34": "फ्रेंड रिक्वेस्ट सफलतापूर्वक भेजी गई",
    "35": "फ्रेंड रिक्वेस्ट सफलतापूर्वक स्वीकार की गई",
    "36": "फ्रेंड रिक्वेस्ट सफलतापूर्वक रद्द की गई",
    "37": "आपने सफलतापूर्वक अनफ्रेंड किया",
    "38": "आपने अनुरोध सफलतापूर्वक अस्वीकार किया",
    "39": "संदेश सफलतापूर्वक भेजा गया"
  },
  "time": {
    "day": "दिन",
    "hour": "घंटे",
    "minute": "मिनट"
  }


}
